import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {
  router
} from './router'
import AMap from 'vue-amap'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MetaInfo from 'vue-meta-info'

import './assets/css/normalize.css'
import './assets/css/animate.min.css'
import 'swiper/dist/css/swiper.css'
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.use(MetaInfo)
Vue.use(AMap)

Vue.config.productionTip = false

AMap.initAMapApiLoader({
  key: '0568819d65d2bcc5269fd59fa70547b0',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title + '-' + '广州埃珥赛璞医疗设备有限公司'
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
